/** @format */

import { pickPortalRole } from "@/dataObject/roles.js";

// Log user in & store token in localStorage & store other data in VUEX
export async function loginService(context, response, token) {
  const user = response?.user;
  if (!user) {
    throw new Error("Unable to log in. Invalid response from server.");
  }

  const roles = Array.isArray(user.roles) ? user.roles : [];
  const practices = Array.isArray(user.practices) ? user.practices : [];
  const primaryRole = pickPortalRole(roles);

  if (!primaryRole) {
    throw new Error(
      "This account has no role assigned. Ask a Super Admin to assign a role, then try again."
    );
  }

  context.commit("setIsLoggedIn", true);
  await context.commit("setUser", user);

  const authToken = token || user.token;
  if (authToken) {
    const time = new Date().toLocaleTimeString();
    localStorage.setItem("token", authToken);
    localStorage.setItem("loginTime", time);
    localStorage.setItem("user_id", user.id);
    context.commit("setToken", authToken);
  } else {
    context.commit("setToken", user.token || null);
  }

  if (practices.length > 1) {
    context.commit("setPractices", practices);
  } else {
    localStorage.setItem("practice", practices[0]?.id ?? "");
    localStorage.setItem("practice_name", practices[0]?.practice_name ?? "");
    localStorage.setItem("assigned_Practices", practices.length);
    localStorage.setItem("region", practices[0]?.region ?? "");
    context.commit("setPractices", practices[0] ?? null);
  }
  localStorage.setItem("role", primaryRole);
  await context.commit("setRoleId", primaryRole);
}
// Clear local & VUEX storage and log user out
export function clearAuth(context) {
  localStorage.clear();
  context.commit("setIsLoggedIn", false);
  context.commit("setUser", {});
  context.commit("setToken", null);
  context.commit("setRoleId", null);
  context.commit("setPractices", null);
}
